/**
 * Converts a numeric amount to Indian Rupee Words representation
 * e.g. 12500 -> "Twelve Thousand Five Hundred Rupees Only"
 */
const ones = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen"
];

const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
];

function convertLessThanThousand(num) {
    let current = "";
    if (num >= 100) {
        current += ones[Math.floor(num / 100)] + " Hundred ";
        num %= 100;
    }
    if (num >= 20) {
        current += tens[Math.floor(num / 10)] + " ";
        num %= 10;
    }
    if (num > 0) {
        current += ones[num] + " ";
    }
    return current;
}

export function numberToWordsRupees(num) {
    if (num === null || num === undefined || isNaN(num)) return "";
    const n = Math.floor(Math.abs(Number(num)));
    if (n === 0) return "Zero Rupees Only";

    let result = "";
    const crore = Math.floor(n / 10000000);
    let rem = n % 10000000;

    const lakh = Math.floor(rem / 100000);
    rem %= 100000;

    const thousand = Math.floor(rem / 1000);
    rem %= 1000;

    if (crore > 0) {
        result += convertLessThanThousand(crore) + "Crore ";
    }
    if (lakh > 0) {
        result += convertLessThanThousand(lakh) + "Lakh ";
    }
    if (thousand > 0) {
        result += convertLessThanThousand(thousand) + "Thousand ";
    }
    if (rem > 0) {
        result += convertLessThanThousand(rem);
    }

    return (result.trim() + " Rupees Only").replace(/\s+/g, " ");
}

export default numberToWordsRupees;
